module.exports = __webpack_public_path__ + "img/sold.98dd0121.png";